exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 1650px) {\n#download-button[data-v-1847b62c] {\n    margin-bottom: 8px;\n}\n}\n", ""]);

// exports
